import React from "react";
import {
  Dialog,
  DialogContent,
  makeStyles,
} from "@material-ui/core";
import Ticket from "../Ticket";

const useStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      width: "90%",
      maxWidth: "1200px",
      height: "90vh",
      maxHeight: "900px",
      margin: theme.spacing(2),
    },
  },
  dialogContent: {
    padding: 0,
    height: "100%",
    overflow: "hidden",
    position: "relative",
  },
}));

const TicketModal = ({
  open,
  onClose,
  ticketId,
  jumpToMessageId = null,
  jumpToMessageTs = null,
  messageHistoryModeOverride = null
}) => {
  const classes = useStyles();

  if (!ticketId) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      className={classes.dialog}
      aria-labelledby="ticket-modal-title"
    >
      <DialogContent className={classes.dialogContent}>
        {/* Autor: GitHub Copilot | Data: 28/03/2026 | Motivo: evitar sobreposição
            entre o botão de fechar do modal e os botões de ação do cabeçalho do ticket. */}
        <Ticket
          ticketIdProp={ticketId}
          isModal={true}
          onCloseModal={onClose}
          jumpToMessageIdProp={jumpToMessageId}
          jumpToMessageTsProp={jumpToMessageTs}
          messageHistoryModeOverride={messageHistoryModeOverride}
        />
      </DialogContent>
    </Dialog>
  );
};

export default TicketModal;
